var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.tag,_vm._g({tag:"component",class:_vm.$options.methods.getClasses(_vm.props, _vm.$style, _vm.data),style:(_vm.$options.methods.getStyles(_vm.props))},_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }